import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

import ImageContainer from './ImageContainer';
import InstagramImport from './InstagramImport';
import { ComplexLabel, RemoveImageIcon, ImportImageButton, MediaItem } from '../../Common';
import imageGraphic from '../../../svg/image-graphic.svg';
import { AnalyticsService } from '../../../services/AnalyticsService';

const SortableItem = SortableElement(({ value, removeImage, index }) => (
  <MediaItem>
    <RemoveImageIcon onClick={() => removeImage(index)}>×</RemoveImageIcon>
    <img src={`${value}`} alt="Offer media" />
  </MediaItem>
));

const SortableList = SortableContainer(({ items, removeImage }) => {
  return (
    <div style={{ overflowX: 'scroll', width: '400px', whiteSpace: 'nowrap' }}>
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          value={value}
          removeImage={(item) => removeImage(item)}
        />
      ))}
    </div>
  );
});

interface Props {
  onChange: Function;
  value: any;
  media: any;
  type: string;
}
interface State {
  igOpen: boolean;
  files: Array<any>;
}

class ImageForm extends Component<Props, State> {

  input: any;

  constructor(props: Props) {
    super(props);
    this.state = { files: props.value || [], igOpen: false };
  }

  addProfileImages(items) {
    items.forEach((item) => {
      const newFile = {
        file: item.media_id,
        preview: item.path,
      };
      this.props.onChange([...this.state.files, newFile]);
      this.setState((state) => {
        return { files: [...state.files, newFile] };
      });
    });
  }

  addInstagramImages(items) {
    this.props.onChange([...this.state.files, ...items]);
    this.setState({ files: [...this.state.files, ...items] });
  }

  handleNewImage(e) {
    e.preventDefault();
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const newFile = { file: files[i], preview: e.target.result };
        this.props.onChange([...this.state.files, newFile]);
        this.setState({ files: [...this.state.files, newFile] });
      };

      // Read in the image file as a data URL.
      reader.readAsDataURL(files[i]);
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const files = arrayMove(this.state.files, oldIndex, newIndex);
    this.setState({
      files,
    });
    this.props.onChange(files);
  };

  removeImage(item: number) {
    const files = [...this.state.files];
    files.splice(item, 1);
    this.setState({ files });
    this.props.onChange(files);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-6">
            <img src={imageGraphic} width="200" alt="Add new" />
          </div>
          <div className="col-6">
            <ImportImageButton
              onClick={() => {
                $('#imageContainerModal').modal('show');
                AnalyticsService.track('Tap Import from Profile - Offer', {});
              }}
            >
              Import from Profile
            </ImportImageButton>
            <ImportImageButton
              onClick={() => {
                this.input.click();
                AnalyticsService.track('Tap Upload from Computer - Offer', {});
              }}
            >
              Upload from Computer
            </ImportImageButton>
            <input
              type="file"
              ref={(input) => (this.input = input)}
              multiple
              style={{ display: 'none' }}
              onChange={(e) => this.handleNewImage(e)}
            />

            {this.props.type !== 'gift' ? (
              <ImportImageButton
              onClick={() => {
                this.setState({ igOpen: true });
                AnalyticsService.track('Tap Import from IG - Offer', {});
              }}
            >
              Import from Instagram
            </ImportImageButton>
            ) : null }
          </div>
        </div>
        <br />
        <div id="items" style={{ overflow: 'auto', whiteSpace: 'nowrap' }} />
        <br />
        <SortableList
          items={this.state.files.map((item) => item.preview)}
          onSortEnd={this.onSortEnd}
          removeImage={(item) => this.removeImage(item)}
          axis="x"
          distance={1}
          lockAxis="x"
        />
        <ComplexLabel
          first="DRAG TO REORDER"
          second="(FIRST IMAGE USED ON LISTINGS SCREEN)"
          row={true}
        />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            marginBottom: '-10px',
            marginLeft: '-49px',
          }}
        />
        <ImageContainer
          images={this.props.media}
          returnImage={(item) => this.addProfileImages(item)}
        />
        <InstagramImport
          open={this.state.igOpen}
          close={() => this.setState({ igOpen: false })}
          returnImage={(item) => this.addInstagramImages(item)}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {

  return {
    businessId: state.business.business_id,
    type: state.newOffer.type,
    media: state.business.media,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageForm);
